import { Form, Card, Spin, Tag } from "antd";
import React, { Component } from "react";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { AccountService } from "../../services/account/AccountService";
import { withRouter } from "react-router-dom";
import Page from "../general/Page";
import "../accounts/Accounts.css";
import "../accounts/AccountForm.css";
import "../accounts/UpdateAccountForm.css";
import { Translation } from "react-i18next";
import i18next from "i18next";
import { handleError } from "../../utils/ErrorHandlers";
class AccountSummary extends Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("accountSummary");
    this.state = {
      account: {},
      isFetching: false,
      formLayout: "inline",
      loading: false,
      cfg: {},
      inputVisible: false,
      inputValue: "",
      tags: [],
    };
  }

  componentDidMount() {
    this.getAccountData();
  }

  async getAccountData() {
    try {
      let id = this.props.context.user.accountId;
      this.acc = new AccountService();

      this.setState({ isFetching: true });
      let account = await this.acc.getAccountsByIdService(
        this.props.context.session_id,
        id
      );
      var cfg = {};
      cfg.pkg_name = "";
      cfg.agents_max_num = "";
      cfg.account_numbers = [];
      cfg.max_concurrent_calls = "";

      if (account.ivrCustomEntityObject.cfg.length) {
        account.ivrCustomEntityObject.cfg.forEach((element) => {
          if (Object.getOwnPropertyNames(element).indexOf("PKG_NAME") > -1) {
            cfg.pkg_name = element["PKG_NAME"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf("AGENTS_MAX_NUMBER") >
            -1
          ) {
            cfg.agents_max_num = element["AGENTS_MAX_NUMBER"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf(
              "CURRENT_ONLINE_AGENTS"
            ) > -1
          ) {
            cfg.current_online_agents = element["CURRENT_ONLINE_AGENTS"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf(
              "MAX_CONCURRENT_CALLS"
            ) > -1
          ) {
            cfg.max_concurrent_calls = element["MAX_CONCURRENT_CALLS"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf(
              "MAX_CONCURRENT_CALLS"
            ) > -1
          ) {
            cfg.current_concurrent_calls = element["CURRENT_CONCURRENT_CALLS"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf("ACCOUNT_NUMBERS") > -1
          ) {
            if (element["ACCOUNT_NUMBERS"] === "") {
              cfg.account_numbers = [];
            } else {
              cfg.account_numbers = element["ACCOUNT_NUMBERS"].split(",");
            }
          }
        });
      }

      this.setState({
        account: account.ivrCustomEntityObject,
        isFetching: false,
        cfg: cfg,
        tags: cfg.account_numbers,
      });
    } catch (error) {
      this.setState({
        isFetching: false,
      });
      handleError(error);
    }
  }

  render() {
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    let { isFetching, tags } = this.state;

    return (
      <Translation>
        {(t) => (
          <Page title={t("Account Summary")} hasBackArrow={true}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                <Card
                  style={{
                    marginTop: "10px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  }}
                  bordered={false}
                >
                  <Form className="form-style" {...formItemLayout}>
                    <Form.Item label={t("Account Name")} {...formItemLayout}>
                      <label>{this.state.account.accountName} </label>
                    </Form.Item>

                    {/* <Form.Item
                      label={t("Account Contact Name")}
                      {...formItemLayout}
                    >
                      <label>{this.state.account.accountContactName} </label>
                    </Form.Item> */}

                    <Form.Item
                      label={t("Account Contact Number")}
                      {...formItemLayout}
                    >
                      <label>
                        {this.state.account.accountContactNumber === "" ||
                        this.state.account.accountContactNumber == null
                          ? this.state.account.accountName
                          : this.state.account.accountContactNumber}{" "}
                      </label>
                    </Form.Item>

                    <Form.Item
                      label={t("Account Contact Email")}
                      {...formItemLayout}
                    >
                      <label>{this.state.account.accountContactEmail} </label>
                    </Form.Item>
                    <Form.Item label={t("Current Package Code")} {...formItemLayout}>
                      <label>{this.state.cfg.pkg_name} </label>
                    </Form.Item>

                    <Form.Item
                      label={t("Max Agents Number")}
                      {...formItemLayout}
                    >
                      <label>{this.state.cfg.agents_max_num} </label>
                    </Form.Item>
                    <Form.Item
                      label={t("Current Online Agents")}
                      {...formItemLayout}
                    >
                      <label>{this.state.cfg.current_online_agents} </label>
                    </Form.Item>
                    <Form.Item
                      label={t("Max Concurrent Calls")}
                      {...formItemLayout}
                    >
                      <label>{this.state.cfg.max_concurrent_calls} </label>
                    </Form.Item>
                    <Form.Item
                      label={t("Current Concurrent Calls")}
                      {...formItemLayout}
                    >
                      <label>{this.state.cfg.current_concurrent_calls} </label>
                    </Form.Item>
                    <Form.Item label={t("Account Numbers")} {...formItemLayout}>
                      <div>
                        {tags.map((tag, index) => {
                          return <Tag key={tag}>{tag}</Tag>;
                        })}
                      </div>
                    </Form.Item>
                  </Form>
                </Card>
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(AccountSummary))
);
